import { render } from "./aboutDih.vue?vue&type=template&id=2c1d784a&scoped=true"
import script from "./aboutDih.vue?vue&type=script&lang=js"
export * from "./aboutDih.vue?vue&type=script&lang=js"

import "./aboutDih.vue?vue&type=style&index=0&id=2c1d784a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1d784a"]])

export default __exports__